/* leverte system – brukt på forsida og i tilbod */
export const CASES = [
  {
    id: "digihome",
    url: "https://digihome.no",
    domain: "digihome.no",
    kind: "SaaS-plattform · Bustadutleige",
    name: "DigiHome",
    img: "/cases/digihome.jpg",
    alt: "DigiHome – plattform for automatisert bustadutleige",
    desc: "Plattform som tek heile bustadutleiga: leigekontraktar signerte med BankID, husleige matcha automatisk mot KID, purring og driftssaker. Utleigaren godkjenner – systemet gjer resten.",
    tags: ["BankID-signering", "KID-matching", "Automatisk purring"],
  },
  {
    id: "fjordferie",
    url: "https://fjordferie.net",
    domain: "fjordferie.net",
    kind: "Bookingplattform · Reiseliv",
    name: "Fjord Ferie",
    img: "/cases/fjordferie.jpg",
    alt: "Fjord Ferie – booking av feriehus i Sunnhordland",
    desc: "Komplett bookingløysing for feriehus i Sunnhordland: søk med datoar og gjester, eigedomssider med prisar og bilete, fleirspråkleg for gjester frå heile Europa.",
    tags: ["Direktebooking", "Fleirspråkleg", "Drift sidan 2001"],
  },
  {
    id: "vestmaskin",
    url: "https://portal.vestmaskinservice.no/",
    domain: "portal.vestmaskinservice.no",
    kind: "Driftsystem · Service og vedlikehald",
    name: "Vest Maskinservice",
    img: "/cases/vestmaskin.jpg",
    alt: "Vest Maskinservice – driftsystem for service og vedlikehald",
    desc: "Internt driftsystem for service og vedlikehald av maskinparken: registrering av service frå mobilen i felt, PDF-rapportar med bilete klare til kunden, og full kontroll på fristar for service og årskontroll. Kundar, maskiner, oljar og filter – på éin stad.",
    tags: ["Mobil i felt", "PDF-rapportar", "Fristvarsling"],
  },
  {
    id: "advokat",
    url: "https://advokat-for-alle.no",
    domain: "advokat-for-alle.no",
    kind: "Plattform · Juridiske tenester",
    name: "Advokat for alle",
    img: "/cases/advokat.jpg",
    alt: "Advokat for alle – digital plattform for juridisk hjelp",
    desc: "Digital plattform som gjer juridisk hjelp enklare: brukaren beskriv saka og lastar opp dokument, teknologien strukturerer opplysningar og fristar, og ein norsk advokat gjev ei skriftleg vurdering – normalt innan 24–48 timar. Fast pris, betaling først når svaret er klart.",
    tags: ["Saksinntak", "AI-forarbeid", "Fast pris"],
  },
  {
    id: "travelease",
    url: "https://travelease.ai",
    domain: "travelease.ai",
    kind: "Driftsystem · Turbuss og transport",
    name: "TravelEase.AI",
    img: "/cases/travelease.jpg",
    alt: "TravelEase.AI – driftsystem for turbusselskap",
    desc: "Driftsystem for turbusselskap som tek heile flyten frå førespurnad til faktura: e-postførespurnader blir tolka automatisk, KI føreslår tilbod, og turen går vidare til planlegging med køyre- og kviletid, sjåførportal, passasjerlister og fakturering via Tripletex. Rundt 500 bestillingar i månaden går gjennom systemet.",
    tags: ["KI-tolka førespurnader", "Køyre- og kviletid", "Tripletex"],
  },
  {
    id: "dutchdate",
    url: "https://dutchdate.app",
    domain: "dutchdate.app",
    kind: "Mobilapp · Forbrukarprodukt",
    name: "DutchDate",
    img: "/cases/dutchdate.jpg",
    alt: "DutchDate – datingapp der begge betaler for seg sjølv",
    desc: "Datingapp for den amerikanske marknaden der kvar betaler for seg sjølv. Matching på verdiar, budsjett og livsstil, bygd som app for Android og iPhone med venteliste og lansering by for by.",
    tags: ["Google Play + iPhone", "Matching", "Lansering i USA"],
  },
];
